/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Preset_Load_PlaceholderInputs */

const en_transcript_export_preset_load_placeholder = /** @type {(inputs: Transcript_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a preset`)
};

const fr_transcript_export_preset_load_placeholder = /** @type {(inputs: Transcript_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner un prereglage`)
};

const de_transcript_export_preset_load_placeholder = /** @type {(inputs: Transcript_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Voreinstellung aus.`)
};

const it_transcript_export_preset_load_placeholder = /** @type {(inputs: Transcript_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un preset`)
};

const ru_transcript_export_preset_load_placeholder = /** @type {(inputs: Transcript_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите предустановку`)
};

const es_transcript_export_preset_load_placeholder = /** @type {(inputs: Transcript_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar un ajuste preestablecido`)
};

const zh_cn2_transcript_export_preset_load_placeholder = /** @type {(inputs: Transcript_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择预设`)
};

const ja_transcript_export_preset_load_placeholder = /** @type {(inputs: Transcript_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを選択`)
};

const hi_transcript_export_preset_load_placeholder = /** @type {(inputs: Transcript_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक प्रीसेट चुनें`)
};

const pt_pt2_transcript_export_preset_load_placeholder = /** @type {(inputs: Transcript_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma predefinição`)
};

/**
* | output |
* | --- |
* | "Select a preset" |
*
* @param {Transcript_Export_Preset_Load_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preset_load_placeholder = /** @type {((inputs?: Transcript_Export_Preset_Load_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preset_Load_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_preset_load_placeholder(inputs)
	if (locale === "de") return de_transcript_export_preset_load_placeholder(inputs)
	if (locale === "it") return it_transcript_export_preset_load_placeholder(inputs)
	if (locale === "ru") return ru_transcript_export_preset_load_placeholder(inputs)
	if (locale === "es") return es_transcript_export_preset_load_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_preset_load_placeholder(inputs)
	if (locale === "ja") return ja_transcript_export_preset_load_placeholder(inputs)
	if (locale === "hi") return hi_transcript_export_preset_load_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_preset_load_placeholder(inputs)
	return en_transcript_export_preset_load_placeholder(inputs)
});